module.exports = __webpack_public_path__ + "static/img/coupons-none.58f3e2f9.png";